/**
 * Canonical timeline defaults shared across layers.
 */

export const DEFAULT_TRACK_HEIGHT = 80;
export const DEFAULT_FPS = 30;
